app.service('accountView', function (
	main, complaintHistory, permissionsBox, loading, message, localStorage, accountChangePaymentView,
	accountUserView, accountDeliveryView, accountInvoicesView, accountReceiverView,
	deliveryCompleting, announcementModal, modal, ePaymentBlikModal, front, deliveryTracking, accountWarrantiesManager,
	customerPersonalDataVerificationModal, subscriptionPaymentsView, subscriptionInvoices, accountConfig, kredytLineRedirect, accountCartRetrieve,
	warrantyUpsellingBox, countdownTimer, warrantyUpsellingPayment, overdueSubscriptionProducts, subscriptionPaymentToast, accountComparisonView, leasing) {
	var config;
	function getMessageKey(complaintType) {
		if (complaintType === "RECLAMATION") {
			return 'complaint-history-reclamation-date-message';
		}
		return 'complaint-history-return-date-message';
	}
	function initPayUOfferModal(){
		var $showPayuOfferButton = $('.js-show-payu-offer-modal');
		if($showPayuOfferButton.length) {
			$showPayuOfferButton.on('click', function(){
				var modalId = $(this).data('payu-offer-modal-id');
				modal.open('about-payu-instalments'+ (modalId != '' ? '-'+modalId : ''));
			});
		}
	}
	function checkSync() {
		const config = accountConfig.getData();
		const data = JSON.parse(localStorage.getItem('PRODUCTS_CLIPBOARD') || '[]');
		if (config?.isUserLogged && data && data.length) {
			console.log('Wymuszona synchronizacja schowka');
			$.ajax({
				url: '/customer-watched-products-force-sync.ltr',
				type: 'POST',
				contentType: 'application/json',
				data: JSON.stringify(data),
				success: function () {
					localStorage.removeItem('PRODUCTS_CLIPBOARD');
					if($('#watched-products').length){
						loading.reload();
					}
				},
				error: function (xhr) {
					console.log('Błąd synchronizacji schowka', xhr.status, xhr.responseText);
				}
			});
		}
	}
	function init() {
		if (!front.katalog) {
			switch (front.page()) {
				case 'complaint-history':
					complaintHistory.init();
					break;
				case 'subscription-payments':
					subscriptionPaymentsView.init();
					break;
				case 'customer-subscription-invoices':
					subscriptionInvoices.init();
					break;
				case 'delivery-completing':
					deliveryCompleting.init();
					break;
				case 'change-payment':
				case 'change-time':
					accountChangePaymentView.init();
					break;
				case 'delivery-address-list':
					accountDeliveryView.init();
					accountReceiverView.init();
					break;
				case 'invoice-address-list':
					accountInvoicesView.init();
					break;
				case 'user-data':
					accountUserView.init();
					break;
				case 'comparison-products':
					accountComparisonView.init();
					break;
			}

			if (front.page() === 'warranty-upselling-payment') {
				warrantyUpsellingPayment.init();
			}

			if (front.page() === 'order-preview') {
				warrantyUpsellingBox.init();
				subscriptionPaymentToast.showFlashMessage();
			}

			if (front.page() === 'order-list-active' || front.page() === "account-main-page") {

				overdueSubscriptionProducts.init();

				$('.warranty-upselling-list-box').each(function () {
					let $box = $(this);
					countdownTimer.create($box.find('.js-upselling-counter'), {
						onEnd() {
							$box.hide();
						}
					});
				});
			}

			if (front.page() === "account-main-page") {
				customerPersonalDataVerificationModal.init();
			}
			if (front.page() === "account-main-page" || front.page() === 'order-list-active' || front.page() === 'order-preview') {
				accountWarrantiesManager.init();
			}

			if (front.page() === "account-main-page" || front.page() === 'order-list-active' || front.page() === 'order-preview') {
				ePaymentBlikModal.init();
			}

			if (front.page() === "account-main-page" || front.page() === 'order-list-active' || front.page() === 'order-preview' || front.page() === 'change-payment') {
				initPayUOfferModal();
			}

			if (front.page() === "order-preview") {
				config = accountConfig.getData();
				if(config.ePaymentType){
					if(config.ePaymentBlik){
						ePaymentBlikModal.load(config.ePaymentType, config.orderNumber);
					}else if(config.ePaymentType === 'TPay'){
						goToTPayAlertRedirectVersion(config.toEPaymentTimeCount, config.orderNumber); // Metoda pochodzi ze starego kodu, jednak jej użycie jest mniej pracochłonnym zadaniem
					}else{
						goToEcardAlert(config.toEPaymentTimeCount, '#LayerPlatnosci'); // Metoda pochodzi ze starego kodu, jednak jej użycie jest mniej pracochłonnym zadaniem
					}
				}
			}
			const $toggleReturnLinksListButton = $('.js-toggle-return-links-list');

			checkSync();
			$('body').on('click', '.js-complaint-history-date-info', function () {
				const complaintType = $(this).data('complaint-type');
				const messageKey = getMessageKey(complaintType);
				message.alert(messageKey);
			}).on('click', '.js-kredytLine-redirect-init', function () {
				var orderNr = $(this).data('order-number');
				kredytLineRedirect.redirect({
					orderNumber: orderNr
				});
			}).on('click', '.js-cart-retrive-action', function () {
				var $this = $(this);
				accountCartRetrieve.action($this.data('action'), $this.data('cart'), $this.data('bundle'));
			}).on('click', '.js-toggle-return-links-list', function () {
				$(this).toggleClass('expanded').attr('aria-expanded', $(this).hasClass('expanded'));
			}).on('click', function (e) {
				if ($toggleReturnLinksListButton.length && !$(e.target).closest('.return-button-box').length) {
					$toggleReturnLinksListButton.filter('.expanded').removeClass('expanded').attr('aria-expanded', 'false');
				}
			});

			leasing.init();
			deliveryTracking.init();
			permissionsBox.init();
			announcementModal.init();
			if ($('#customer-account-error-data').length && localStorage.getItem('customer-account-error-data') !== 's') {
				message.get('account - no-all-account-data').then(function (html) {
					modal.generate({
						content: html,
						id: 'no-all-account-data',
						buttons: [{
							text: 'Uzupełnij brakujące dane',
							click: function () {
								loading.redirect($('#customer-account-error-data a.button').attr('href'));
							}
						}]
					});
					localStorage.setItem('customer-account-error-data', 's');
				});
			}
		}
	}

	permissionsBox.checkPermissions();
	main.onLoad(init);
	$(document).on('pageChange', init);
});
